import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import UnidadeMedidaModel from "@/models/unidadeMedidaModel";
import unidadeMedidaService from "@/services/unidadeMedidaService";

import ListComponentBase from "../listComponentBase";

import "../crud.scss";

@Component
export default class UnidadeMedidaListComponent extends ListComponentBase<UnidadeMedidaModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("descricao", this.$t("__.ts.descricao"), GridColumnType.String),
            new GridColumn("sigla", "Sigla", GridColumnType.String),
        ];
    }

    private beforeMount() {
        this.setPropsCached(unidadeMedidaService, "unidademedida", "descricao", true);
    }
}
